import { PropsFromReduxProtheses } from '../containers/ProtheseContainer'
import {
  DataGridPro,
  GridColumns,
  GridRenderCellParams,
  GridValueGetterParams,
} from '@mui/x-data-grid-pro'
import React, { useEffect, useRef, useState} from 'react'
import { Toolbar } from './Table/Toolbar'
import Loader from '../../common/Loader'
import { Box, Tab, Tabs } from '@mui/material'
import {
  prosthesisGammeName,
  prosthesisRangeName,
} from '../../../utils/patientInfos'
import moment from 'moment'
import { companyClickableIconsNameMap } from '../../../utils/constants'
import PaginationComponent from '../../common/PaginationComponent';
import {useLocation} from 'react-router-dom';
import {ILeadReference, IProsthesisReference} from '../reducers';

const ProtheseComponent = (props: PropsFromReduxProtheses) => {
  const location = useLocation()
  const q = useRef(new URLSearchParams(location.search)).current
  const [data, setData] = useState<ILeadReference[]|IProsthesisReference[]>([])
  const [rowsPerPage, setRowsPerPage] = useState(
      q.has('limit')
          ? parseInt(q.get('limit') as string)
          : parseInt(localStorage.getItem('rowsPerPage') as string),
  )
  const [activePage, setActivePage] = useState(q.has('page') ? parseInt(q.get('page') as string) : 1,)
  const [activeTab, setActiveTab] = useState(0)
  const [activeToolBar, setActiveToolBar] = useState({})
  const [columns, setColumns] = useState<GridColumns>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [searchText, setSearchText] = useState('')
  const [selectedGammes, setSelectedGammes] = useState<string[]>([])
  const [selectedMakerIds, setSelectedMakerIds] = useState<number[]>([])

  useEffect(() => {
    // props.getCompany(20, 0, '', false)
    props.getCountry()
    props.getGammeRange(20, 0)
    props.getMakers()
    props.getProsthesisReferencesSummary()
    props.getLeadReferenceSummary()
    props.getTransmitterReferenceSummary()
    props.getLeadReferenceConnexions()
  }, []) //eslint-disable-line

  useEffect(() => {
    switch (activeTab) {
      case 0:
        props.getProsthesisReference(rowsPerPage, activePage, searchText, selectedGammes, selectedMakerIds)
        break
      case 1:
        props.getTransmitterReferences(rowsPerPage, activePage, searchText, selectedMakerIds)
        break
      case 2:
        props.getLeadsReferences(rowsPerPage, activePage, searchText, selectedMakerIds)
        break
    }
  }, [searchText, selectedGammes, selectedMakerIds, activeTab]) //eslint-disable-line

  useEffect(() => {
    if (props.gammeRange) {
      setLoading(false)
    } else {
      setLoading(true)
    }
  }, [props.gammeRange])
  
  useEffect(() => {
    setActivePage(1)
    switch (activeTab) {
      case 0:
        setColumns(columnsProsthesis)
        setActiveToolBar(prosthesisToolBar)
        break
      case 1:
        setColumns(columnsTransmitters)
        setActiveToolBar(transmitterToolBar)
        break
      case 2:
        setColumns(columnsLeads)
        setActiveToolBar(leadsToolBar)
        break
      default:
        setColumns([])
    }
  }, [activeTab])
  
  useEffect(() => {
    switch (activeTab) {
      case 0:
        props.getProsthesisReference(rowsPerPage, activePage, searchText, selectedGammes, selectedMakerIds)
        break
      case 1:
        props.getTransmitterReference(rowsPerPage, activePage, searchText, selectedMakerIds)
        break
      case 2:
        props.getLeadsReferences(rowsPerPage, activePage, searchText, selectedMakerIds)
        break
    }
  }, [rowsPerPage, activePage])
  
  useEffect(() => {
    if (activeTab === 0) {
      !loading ? setData(props.prosthesisReferences) : setData([])
    } else if (activeTab === 1) {
      !loading ? setData(props.transmitterReferences) : setData([])
    } else if (activeTab === 2) {
      !loading ? setData(props.leadsReferences) : setData([])
    }
  }, [loading, props.prosthesisReferences, props.leadsReferences, props.transmitterReferences, activeTab])
  

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue)
    setActivePage(1)
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  }
  
  const prosthesisToolBar = {
    title: 'Références de prothèses',
    searchText,
    setSearchText,
    selectedGammes,
    setSelectedGammes,
    selectedMakerIds,
    setSelectedMakerIds,
    makers: props.makers.data,
    type: 'PROSTHESIS',
    leadConnexions: []
  }
  
  const leadsToolBar = {
    title: 'Références de sondes',
    searchText,
    setSearchText,
    selectedGammes,
    setSelectedGammes,
    selectedMakerIds,
    setSelectedMakerIds,
    makers: props.makers.data,
    type: 'LEAD',
    leadConnexions: props.leadConnexions
  }
  
  const transmitterToolBar = {
    title: 'Références de transmetteurs',
    searchText,
    setSearchText,
    selectedGammes,
    setSelectedGammes,
    selectedMakerIds,
    setSelectedMakerIds,
    makers: props.makers.data,
    type: 'TRANSMITTER',
    leadConnexions: []
  }
  
  const columnsLeads: GridColumns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 70,
      sortable: false,
      valueGetter: (params: GridValueGetterParams) => `${params.row.id}`,
    },
    {
      field: 'col1',
      headerName: 'Référence',
      width: 200,
      sortable: false,
      valueGetter: (params: GridValueGetterParams) =>
          `${params.row.reference}`,
    },
    {
      field: 'col2',
      headerName: 'Description',
      width: 200,
      sortable: false,
      valueGetter: (params: GridValueGetterParams) =>
          `${params.row.description}`,
    },
    {
      field: 'col3',
      headerName: 'Longueur (mm)',
      width: 130,
      sortable: false,
      valueGetter: (params: GridValueGetterParams) =>
          `${params.row.length}`,
    },
    {
      field: 'col4',
      headerName: 'Fabricant',
      width: 100,
      sortable: false,
      renderCell: (params: GridRenderCellParams) => {
        // Ensure 'params' is correctly typed
        return params.row.company?.company_name ? (
            companyClickableIconsNameMap[params.row.company.company_name]
        ) : (
            <></>
        )
      },
    },
   
    {
      field: 'col6',
      headerName: 'Type',
      width: 100,
      sortable: false,
      valueGetter: (params: GridValueGetterParams) =>
          `${params.row.lead_connection?.lead_type}`,
    },
    {
      field: 'col7',
      headerName: 'Connexion',
      width: 100,
      sortable: false,
      valueGetter: (params: GridValueGetterParams) =>
          `${params.row.lead_connection?.lead_connection}`,
    }
  ]
  
  const columnsTransmitters: GridColumns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 70,
      sortable: false,
      valueGetter: (params: GridValueGetterParams) => `${params.row.id}`,
    },
    {
      field: 'col1',
      headerName: 'Référence',
      width: 200,
      sortable: false,
      valueGetter: (params: GridValueGetterParams) =>
          `${params.row.reference_name}`,
    },
    {
      field: 'col2',
      headerName: 'Modèle',
      width: 200,
      sortable: false,
      valueGetter: (params: GridValueGetterParams) =>
          `${params.row.transmitter_model ? params.row.transmitter_model : ''}`,
    },
    {
      field: 'col4',
      headerName: 'Fabricant',
      width: 100,
      sortable: false,
      renderCell: (params: GridRenderCellParams) => {
        // Ensure 'params' is correctly typed
        return params.row.company?.company_name ? (
            companyClickableIconsNameMap[params.row.company.company_name]
        ) : (
            <></>
        )
      },
    },
  ]
  
  const columnsProsthesis: GridColumns = [
      {
        field: 'id',
        headerName: 'ID',
        width: 70,
        sortable: false,
        valueGetter: (params: GridValueGetterParams) => `${params.row.id}`,
      },
      {
        field: 'col1',
        headerName: 'Modèle',
        width: 150,
        sortable: false,
        valueGetter: (params: GridValueGetterParams) =>
          `${params.row.referenceName}`,
      },
      {
        field: 'col2',
        headerName: 'Référence',
        width: 200,
        sortable: false,
        valueGetter: (params: GridValueGetterParams) =>
          `${params.row.prosthesisModel}`,
      },
      {
        field: 'col3',
        headerName: 'Gamme',
        width: 200,
        sortable: false,
        valueGetter: (params: GridValueGetterParams) =>
            `${prosthesisGammeName(params.row?.prosthesisGamme?.stringKey)}`,
      },
      {
        field: 'col4',
        headerName: 'Segment',
        width: 200,
        sortable: false,
        valueGetter: (params: GridValueGetterParams) =>
            `${prosthesisRangeName(params.row?.prosthesisRange?.stringKey)}`,
      },
      {
        field: 'col5',
        headerName: 'Fabricant',
        width: 100,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => {
          // Ensure 'params' is correctly typed
          return params.row.maker?.companyName ? (
            companyClickableIconsNameMap[params.row.maker.companyName]
          ) : (
            <></>
          )
        },
      },
      {
        field: 'createdAt',
        headerName: 'Date de création',
        width: 100,
        minWidth: 250,
        sortable: true,
        valueGetter: (params: GridValueGetterParams) =>
          params.row.createdAt
            ? `${moment(params.row.createdAt).format('DD-MM-YYYY')}`
            : '',
        sortComparator: (v1, v2) => {
          const date1 = v1
            ? moment(v1, 'DD-MM-YYYY').toDate()
            : new Date('01-01-1990')

          const date2 = v2
            ? moment(v2, 'DD-MM-YYYY').toDate()
            : new Date('01-01-1990')
          return date1.getTime() - date2.getTime()
        },
      },
      {
        field: 'col6',
        headerName: '€',
        width: 100,
        minWidth: 250,
        sortable: false,
        valueGetter: (params: GridValueGetterParams) =>
          `${
            params.row?.billableList && params.row.billableList.length > 0
              ? 'Référence facturable'
              : ''
          } `,
      },
    ]
  

  return (
    <>
      <Box sx={{ height: 'calc(100vh - 240px)', width: '100%' }}>
        <Loader open={loading} text="En attente" />
        <Tabs
          TabIndicatorProps={{
            style: {
              backgroundColor: '#ffa726',
              display: 'flexWrap',
            },
          }}
          onChange={handleTabChange}
          textColor="primary"
          value={activeTab}
        >
          <Tab
            label={`Références de prothèses : ${
              loading ? 0 : props.prosthesisReferencesCount
            }`}
            {...a11yProps(0)}
            wrapped={false}
          />
          <Tab
            label={`Références de transmetteurs : ${
              loading ? 0 : props.transmitterReferenceCount
            }`}
            {...a11yProps(0)}
            wrapped={false}
          />
          <Tab
            label={`Références de sondes : ${
              loading ? 0 : props.leadReferenceCount
            }`}
            {...a11yProps(0)}
            wrapped={false}
          />
         
          
        </Tabs>

        <DataGridPro
          rows={data ? data : []}
          columns={columns}
          components={{
            Toolbar,
          }}
          pagination={false}
          componentsProps={{
            toolbar: activeToolBar,
            pagination: false,
          }}
          pageSize={rowsPerPage}
          hideFooter
          rowsPerPageOptions={undefined}
          rowHeight={60}
          disableColumnMenu
          disableSelectionOnClick
          sx={{
            border: 'none',
            padding: '3px 15px',
          }}
        />
        <PaginationComponent
            pages={0}
            activePage={activePage}
            rowsPerPage={rowsPerPage}
            setActivePage={setActivePage}
            setRowsPerPage={setRowsPerPage}
        />
      </Box>
    </>
  )
}

export default ProtheseComponent
